import { render } from "./SignUpScreen.vue?vue&type=template&id=21b3854c"
import script from "./SignUpScreen.vue?vue&type=script&lang=js"
export * from "./SignUpScreen.vue?vue&type=script&lang=js"

import "./SignUpScreen.vue?vue&type=style&index=0&id=21b3854c&lang=css"
script.render = render

export default script